import { Stack, Text } from "@mantine/core"

import {
  CommunicationStudioClasses,
  CUSTOMISATION_CATEGORIES,
} from "@tfg/types/constants/communication-studio.constant"
import { ComponentContent } from "@tfg/types/schemas/communication-studio/components"
import {
  contentVerticalSpacingCSSVariable,
  headerFontFamilyCSSVariable,
  headerLineHeightCSSVariable,
  titleColorCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import { useGetStylingParametersContext } from "../context/stylingParameters/useGetStylingParametersContext"
import { useGetContentInLanguage } from "../page-components/TextParagraph"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"
import { isTextContentJSONArray } from "../utils/utils"

type TextHeaderProps = {
  content: ComponentContent
}
export const TextHeader = ({ content }: TextHeaderProps) => {
  const { stylingParameters } = useGetStylingParametersContext()
  const contentBlock = useGetContentInLanguage(content)
  if (!contentBlock || !contentBlock[0]) {
    return null
  }

  return (
    <>
      {contentBlock.map((block) => {
        if (!isTextContentJSONArray(block.textContent)) {
          console.warn(
            "TextHeader: textContent is not a TextContentJSON array, skipping block"
          )
          return null
        }
        const textContent = block.textContent

        return textContent.map((text, index) => (
          <Stack
            key={`text-header-${index}`}
            gap={DesignStudioParametersToolkit.getCssVariableLiteralName(
              contentVerticalSpacingCSSVariable
            )}
            c={DesignStudioParametersToolkit.getCssVariableLiteralName(
              titleColorCSSVariable
            )}
          >
            <Text
              className={CommunicationStudioClasses.SUB_TEXT_HEADER}
              ff={`${DesignStudioParametersToolkit.getCssVariableLiteralName(
                headerFontFamilyCSSVariable
              )}, ${DesignStudioParametersToolkit.extractFontFamily(stylingParameters)}`}
              style={DesignStudioParametersToolkit.spreadStylingParameters({
                category: CUSTOMISATION_CATEGORIES.GLOBAL,
                stylingParameters,
                stylingParamKeys: ["letterSpacing"],
              })}
              lh={DesignStudioParametersToolkit.getCssVariableLiteralName(
                headerLineHeightCSSVariable
              )}
            >
              {text.text}
            </Text>
          </Stack>
        ))
      })}
    </>
  )
}
